import { render } from "./ReferralComponent.vue?vue&type=template&id=e0615e7c&scoped=true"
import script from "./ReferralComponent.vue?vue&type=script&lang=js"
export * from "./ReferralComponent.vue?vue&type=script&lang=js"

import "@/assets/styles/components/modules/checkout/referral.styl?vue&type=style&index=0&id=e0615e7c&lang=stylus&scoped=true"
import "./ReferralComponent.vue?vue&type=style&index=1&id=e0615e7c&lang=scss&scoped=true"

import exportComponent from "/runner/_work/cb-checkout/cb-checkout/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0615e7c"]])

export default __exports__